import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import './ViewShipment.css';

const ViewShipment = () => {
  const [consignments, setConsignments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchConsignments = async () => {
      try {
        const response = await axios.get("https://kartikenterprisesindia.co.in/api/consignments");
        setConsignments(response.data);
      } catch (error) {
        alert("Failed to fetch consignments.");
      }
    };

    fetchConsignments();
  }, []);

  const handleDelete = async (consignmentId) => {
    if (window.confirm("Are you sure you want to delete this consignment?")) {
      try {
        await axios.delete(`https://kartikenterprisesindia.co.in/api/consignments/${consignmentId}`);
        setConsignments(consignments.filter((c) => c._id !== consignmentId));
        alert("Consignment deleted successfully.");
      } catch (error) {
        alert("Failed to delete consignment.");
      }
    }
  };

  return (
    <div className="view-consignments">
      <h2>Consignments</h2>
      <button
        className="create-button"
        onClick={() => navigate("/createconsignment")}
      >
        + Create Consignment
      </button>
      <table>
        <thead>
          <tr>
            <th>Consignment Number</th>
            <th>Date of Consignment</th>
            <th>From (Sender City)</th>
            <th>To (Receiver City)</th>
            <th>Status</th>
            <th>Edit</th>
            <th>del</th>
          </tr>
        </thead>
        <tbody>
          {consignments.map((consignment) => (
            <tr key={consignment._id}>
              <td>{consignment.consignmentNumber}</td>
              <td>{new Date(consignment.dateOfConsignment).toLocaleDateString()}</td>
              <td>{consignment.sender.city}</td> {/* Sender City */}
              <td>{consignment.receiver.city}</td> {/* Receiver City */}
              <td>{consignment.status}</td>
              <td>
                <button
                  className="action-button edit-button"
                  onClick={() => navigate(`/editconsignment/${consignment._id}`)}
                >
                  ✏️
                </button>
              </td>
              <td>
                <button
                  className="action-button delete-button"
                  onClick={() => handleDelete(consignment._id)}
                >
                  🗑️
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ViewShipment;
